export default {
  props: {
    hasLogo: {
      type: Boolean,
      default: false,
    },
  },
}
